import axios from "axios";
import { resolveApiUrl } from "../../assets/GlobalVariables";
import { getSessionId } from "../../services/authService";

async function opsGet(path) {
  const sessionID = await getSessionId();
  const sid = sessionID ? String(sessionID).trim() : "";
  if (!sid) {
    const error = new Error("unauthorized");
    error.status = 401;
    throw error;
  }
  const { data } = await axios.get(resolveApiUrl(path), {
    headers: { "X-Session-ID": sid, Accept: "application/json" },
    withCredentials: true,
    timeout: 20000,
  });
  return data;
}

export function fetchTripMasterOpsSearches() {
  return opsGet("/api/tripmaster/ops/searches");
}

export function fetchTripMasterOpsOrders() {
  return opsGet("/api/tripmaster/ops/orders");
}

export function fetchTripMasterOpsOrderDetail(orderId) {
  const id = encodeURIComponent(String(orderId || "").trim());
  return opsGet(`/api/tripmaster/ops/orders/${id}`);
}
